import { 
    SAVE_INTEGRATION_REQUEST, 
    SAVE_INTEGRATION_SUCCESS, 
    SAVE_INTEGRATION_FAILURE,
    FETCH_KLAVIYO_TEMPLATES_REQUEST,
    FETCH_KLAVIYO_TEMPLATES_SUCCESS,
    FETCH_KLAVIYO_TEMPLATES_FAILURE,
    FETCH_PARCEL_PANEL_REQUEST,
    FETCH_PARCEL_PANEL_SUCCESS,
    FETCH_PARCEL_PANEL_FAILURE,
} from "../actions/integrationAction";

const initialState = {
    loading: false,
    integrations: [],
    klaviyoTemplates: [],
    error: "",
    parcelPanelEnabled: false
};

const integrationReducer = (state = initialState, action) => {
    switch (action.type) {
    case SAVE_INTEGRATION_REQUEST:
    case FETCH_PARCEL_PANEL_REQUEST:
    case FETCH_KLAVIYO_TEMPLATES_REQUEST:
        return { ...state, loading: true };
    case SAVE_INTEGRATION_SUCCESS:
        return {
            ...state,
            loading: false,
            integrations: action.payload,
            error: "",
        };
    case FETCH_KLAVIYO_TEMPLATES_SUCCESS:
        return {
            ...state,
            loading: false,
            klaviyoTemplates: action.payload,
            error: "",
        };
    case FETCH_PARCEL_PANEL_SUCCESS:
        return {
            ...state,
            loading: false,
            parcelPanelEnabled: action.payload,
            error: "",
        };
    case SAVE_INTEGRATION_FAILURE:
    case FETCH_PARCEL_PANEL_FAILURE:
    case FETCH_KLAVIYO_TEMPLATES_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.payload,
        };
    default:
        return state;
    }
};

export default integrationReducer;